export default __webpack_public_path__ + "static/media/icons-controls.17a94c78.svg";